import React from 'react';

import type {
  EvaErrorBoundaryProps,
  EvaErrorBoundaryState,
} from '../types/components';

export class EvaErrorBoundary extends React.Component<
  EvaErrorBoundaryProps,
  EvaErrorBoundaryState
> {
  state: EvaErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): EvaErrorBoundaryState {
    return { hasError: true };
  }

  render(): React.ReactNode {
    if (this.state.hasError) {
      return this.props.fallback ?? null;
    }

    return this.props.children;
  }
}

export default EvaErrorBoundary;
